
import Slidetify from "@/components/Slidetify.vue";
import Request from "@/ts/Request";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    btnAtive: String,
    btnDisabled: String,
    nameButton: String,
    className: String,
    classComponent: String,
    icon: String,
    classDiv: String,
    idComponent: String,
    routerGo: String,
    iconClass: String,
    openThis: Function,
    isTour: Boolean,
    iconActive: String,
  },
})
export default class BottomNavigation extends Vue {
  static navigationItems = [];
  static defaultItems = [
    { id: "0", name: "Início", icon: ["fal", "home"], router: "HomeFeed" },
    {
      id: "1",
      name: "Pedidos",
      icon: ["fal", "utensils"],
      router: "MenuPedidos",
    },
    {
      id: "2",
      name: "Eventos",
      icon: ["fal", "compass"],
      router: "EventsMenu",
    },
    {
      id: "3",
      name: "Serviços",
      icon: ["fal", "sparkles"],
      router: "ServicesMenu",
    },
    {
      id: "4",
      name: "Agenda",
      icon: ["fal", "calendar"],
      router: "ServicesSchedule",
    },
    { id: "5", name: "Comprar", icon: ["fal", ""], router: "Lojas" },
    { id: "6", name: "Carteira", icon: ["fal", ""], router: "Carteira" },
    { id: "7", name: "Perfil", icon: ["fal", ""], router: "Perfil" },
    { id: "8", name: "Início", icon: ["fal", ""], router: "HomeFeed" },
    { id: "9", name: "Ouvidoria", icon: ["fal", ""], router: "SupportRequest" },
    {
      id: "10",
      name: "Minhas Compras",
      icon: ["fal", ""],
      router: "PedidosRealizados",
    },
    { id: "13", name: "Início", icon: ["fal", "home"], router: "HomeRelease" },
    { id: "14", name: "Início", icon: ["fal", "home"], router: "HomeLojas" },
  ];

  static organizationData: any = {};

  clssIconColor = "icon-footer-color";
  bottomNavigation = "bottom-navigation";
  bottomNavigationTour = "bottom-navigation-tour";

  analytics: boolean = sessionStorage.getItem("ANALYTICS_KEY") ? true : false;
  componentKey = 0;

  static instance: any;
  options: any = BottomNavigation.navigationItems;

  classPrimary = "primary-color";
  selectedOption = "0";
  nrorg = Number(sessionStorage.getItem("NRORG"));
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");

  mounted() {
    BottomNavigation.instance = this;
  }

  static refresh() {
    const layoutConfig = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    ).CONFIGURATIONS.APP_LAYOUT_CONFIG;

    if (layoutConfig === undefined) {
      this.getOrganizationData();
      return;
    }

    BottomNavigation.organizationData = layoutConfig.BottomNavigation;

    BottomNavigation.navigationItems = BottomNavigation.organizationData.map(
      (i: any) => {
        const item = BottomNavigation.defaultItems.find(
          (o: any) => i.id == o.id
        );
        if (!item) BottomNavigation.navigationItems = [];

        return {
          ...item,
          name: i.name,
          icon: i.icon.map(() => ["fal", i.icon[0]])[0],
        };
      }
    );

    const instance = BottomNavigation.instance;
    if (instance) {
      instance.options = BottomNavigation.navigationItems;
    }

    return BottomNavigation.navigationItems;
  }

  handleClick(option: any, id: any) {
    let latitude: number | null =
      Number(sessionStorage.getItem("LATITUDE")) || null;
    let userId: number | null =
      Number(sessionStorage.getItem("USER_ID")) || null;
    const userData: any = JSON.parse(
      sessionStorage.getItem("USER_DATA") || "{}"
    );

    if (option.router == "HomeRelease") {
      this.$router.push(option.router);
      sessionStorage.setItem("GO_TO_STORE", "false");
      sessionStorage.setItem("BALCONY", "false");
      sessionStorage.removeItem("DELIVER_AT");
    } else if (latitude === null) {
      if (userId === null) {
        this.$router.push(option.router);
      } else if (userData.ADDRESS.length > 0) {
        sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
        sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
        this.$router.push(option.router);
      } else {
        // this.$router.push("AddAddress");
        this.$router.push(option.router);
      }
    } else {
      this.$router.push(option.router);
    }
  }

  openMenuOptions() {
    this.$emit("buttonCallBack");
  }

  static getOrganizationData() {
    const self = this;
    const req = new Request();
    req.body = {
      NRORG: sessionStorage.getItem("NRORG"),
      USER_ID: sessionStorage.getItem("USER_ID"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      USER_TYPE_ID: 1,
    };
    req.route = "getOrganizationData";
    req.callbackSuccess = (response: any) => {
      sessionStorage.setItem(
        "ORGANIZATION_DATA",
        JSON.stringify(response.organization)
      );

      const bn: any = BottomNavigation;
      const sn: any = Slidetify;
      bn.refresh();
      sn.refresh();
    };
    req.callbackError = (error: any) => {};
    req.loadingMessage = "Preparando o aplicativo...";
    req.showLoader = false;
    req.blockTouchEvents = true;
    req.send();
  }
}
